module.exports = __webpack_public_path__ + "static/img/zsyh.b2839ddd.png";